import { getCountryCode, getEmojiFlag } from "countries-list";
import { TalentClass } from "src/classes/models/talent";
import { UserAvatar } from "src/components/Avatar";
import Button from "src/components/Button";
import { Talent } from "src/types";

const TalentCard = ({ talent }: { talent: Talent }) => {
  const _talent = new TalentClass(talent);
  return (
    <div className="w-full bg-white rounded-lg p-3">
      <CardBody talent={talent} />

      <div className="mt-4 flex justify-between items-center">
        <p className="font-poppins text-xl font-semibold">{_talent.salaryText()}</p>
        <Button
          onClick={() => window.open("/talent/" + talent.freelancer_id, "_blank")}
          className="!w-fit !px-4"
        >
          View Profile
        </Button>
      </div>

      <p className="font-poppins text-sm mt-3">{talent.city || ""}</p>
    </div>
  );
};

export const CardBody = ({ talent }: { talent: Talent }) => {
  const t = new TalentClass(talent);
  const { filter_skills, level_of_experience, country } = talent;
  const countryCode = getCountryCode(country);
  const openTo = t.termToText();
  return (
    <div className="w-full py-5 px-3 rounded-md bg-[#F9F9F9] ">
      <div className="flex gap-[10px]">
        <UserAvatar wrapperClassName={`!w-[56px] !h-[56px] `} user={talent.User} />
        <div className="font-poppins ">
          <p className="font-semibold text-xl">{talent.User.full_name}</p>
          <p className="text-base mt-[2px]">{talent.Role?.name || ""}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {filter_skills &&
          JSON.parse(filter_skills).map((skill, index) => <Tag key={index}>{skill}</Tag>)}
        {level_of_experience && <Tag>{level_of_experience}</Tag>}
        {countryCode && (
          <Tag>
            <div className="flex items-center">
              <p className="text-xl h-[20px] -translate-y-1">{getEmojiFlag(countryCode)}</p>
              <p> &nbsp; {country}</p>
            </div>
          </Tag>
        )}
        {openTo && <Tag>{openTo.replaceAll(", ", " / ")}</Tag>}
      </div>
    </div>
  );
};

const Tag = ({ children }) => (
  <div className="bg-white shadow-sm font-poppins text-sm text-center rounded-full py-2 px-4 ">
    {children}
  </div>
);

export default TalentCard;
